import { flowIdPiaBoatOfferFlow } from '../../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../../flows/src/hooks/useFlowsResetState';

const useStartPiaBoatOfferFlow = (): ((uuid: string) => Promise<void>) => {
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();

  return async (uuid?: string) => {
    reset();

    const flowPayload = {
      company: ['pia'],
      // insurance_type: ['boat'],
    };

    // TODO: Uncomment when boat risk object is implemented
    // louiseDispatch(pushToSelectedRiskObjects(['boat']));
    // if (uuid) setSelectionState(uuid, flowPayload);

    await initFlow({
      flowId: flowIdPiaBoatOfferFlow,
      payload: flowPayload,
      outputUrl: `/sales-conversation/offers/overview/boat`,
      sessionId: uuid,
    });
  };
};

export default useStartPiaBoatOfferFlow;
